var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessageSuccess16(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconSuccess16",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,0 C12.4163197,0.00472418273 15.9952758,3.5836803 16,8 C16,12.418278 12.418278,16 8,16 C3.581722,16 0,12.418278 0,8 C0,3.581722 3.581722,0 8,0 Z M8,1.14285714 C4.21290457,1.14285714 1.14285714,4.21290457 1.14285714,8 C1.14285714,11.7870954 4.21290457,14.8571429 8,14.8571429 C11.7853983,14.8530487 14.8530487,11.7853983 14.8571429,8 C14.8571429,4.21290457 11.7870954,1.14285714 8,1.14285714 Z M10.5371429,5.39257143 C10.7523495,5.1697515 11.0710382,5.0803892 11.3707206,5.15883101 C11.6704029,5.23727281 11.9044415,5.47131135 11.9828833,5.77099372 C12.0613251,6.07067609 11.9719628,6.38936474 11.7491429,6.60457143 L11.7491429,6.60457143 L7.17771429,11.176 C6.84456351,11.5090653 6.30506346,11.5108518 5.96971429,11.18 L5.96971429,11.18 L3.684,8.92571429 C3.34694851,8.59323887 3.34323887,8.05048006 3.67571429,7.71342857 C4.00818971,7.37637708 4.55094851,7.37266744 4.888,7.70514286 L4.888,7.70514286 L6.56742857,9.36228571 L10.5371429,5.39314286 Z",
    id: "Combined-Shape",
    fill: "#177D3D"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageSuccess16);
export default __webpack_public_path__ + "static/media/messageSuccess16.79e00b02d04c8e34e054f0f14a9a274e.svg";
export { ForwardRef as ReactComponent };